module.exports = __webpack_public_path__ + "img/denstone college.20330c73.jpg";